import { Outlet } from "react-router";
import { Sidebar } from "../features/sidebar/Sidebar";
import { AppFrame, MainFrame } from "./ProtectedRoutes";
import { CompanySidebarPart } from "../features/sidebar/CompanySidebarPart.js";
import { CompanySidebarFooterLinks } from "../features/sidebar/CompanySidebarFooterLinks.js";
import { AiPendingNotifications } from "../features/ai-chat/components/AiPendingNotifications.js";
import { useLoadedCompanyDomain } from "./routeDataHooks.js";
import { useSyncScopeFromUrl } from "./useSyncScopeFromUrl.js";
import { ScopeChangeGuard } from "./ScopeChangeGuard.js";
import { UnsavedChangesProvider } from "./unsavedChanges.js";

export const CompanyRouteLayout = () => {
	const companyDomain = useLoadedCompanyDomain();
	useSyncScopeFromUrl();
	return (
		<UnsavedChangesProvider>
			<AppFrame>
				<ScopeChangeGuard />
				<Sidebar
					renderFooter={() => (
						<>
							<CompanySidebarFooterLinks />
						</>
					)}
					renderContent={({ sidebarOpen }) => (
						<CompanySidebarPart sidebarOpen={sidebarOpen} />
					)}
				/>
				<MainFrame>
					<AiPendingNotifications companyDomainId={companyDomain.id} />
					<Outlet />
				</MainFrame>
			</AppFrame>
		</UnsavedChangesProvider>
	);
};
